import React, { useContext, useEffect, useState } from 'react';
import { FilterProps } from '../../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../../util/color.util';
import MultiSelectionList from '../../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../../common/SearchBar/SearchBar';
import { CustomFieldPropertiesFilter } from '../CustomFieldPropertiesFilter';
import { CustomFieldContext } from '../../../../../../context/CustomFieldContext';

interface CustomFieldPropertiesFilterDropdownContentProps {
  filter: CustomFieldPropertiesFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export function CustomFieldPropertiesFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: CustomFieldPropertiesFilterDropdownContentProps) {
  const { customFields } = useContext(CustomFieldContext);
  const [query, setQuery] = useState<string>('');

  const filterCustomField = () => {
    const items = new Set<string>();
    for (const item of customFields.values()) {
      if (!filter.search(item, query)) continue;
      if (filterProps.company?.size && !filterProps.company.has(item.companyId)) continue;
      items.add(item.name);
    }

    return items;
  };

  const [values, setValues] = useState<Set<string>>(filterCustomField());

  const handleChange = (selected: Set<string>) => {
    filterProps.customField = selected;
    if (!filterProps.customField?.size) filterProps.customField = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.customField = undefined;
    setFilterProps({ ...filterProps });
  };

  useEffect(() => {
    setValues(filterCustomField());
  }, [query]);

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-ventory-grey-500 text-[13px] font-[500]'>{filter.toLabel()}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.customField}
          values={values}
          onChange={handleChange}
          toText={id => id}
        />
      </Grid>
    </Grid>
  );
}
